<template>
    <v-form
        ref='init-manager-balance-form'
        lazy-validation
        v-model='validInitManagerBalance'
        :disabled='loadingSubmitInitManagerBalance'
        @submit.prevent='createInvoice(managerBalance)'
    >
        <v-row>
            <!--managerBalance-->
            <v-col cols='12'>
                <CustomCurrencyInput
                    v-model='managerBalance'
                    :rules='rules.managerBalance'
                    type='number'
                    hint='لطفا کیبورد خود را انگلیسی کنید'
                    persistent-hint
                    :disabled='disabled'
                    :min='0'
                    :max='9005000000000000'
                    :step='500000'
                    suffix='تومان'
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        موجودی نزد مدیر
                    </template>
                </CustomCurrencyInput>
            </v-col>
            <v-col cols='12'>
                <v-card-actions class='pa-0'>
                    <v-btn
                        outlined
                        @click='goToStep(step-1)'
                    >
                        مرحله قبل
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        :loading='loading'
                        :disabled='loading || !validInitManagerBalance'
                        name='submit'
                        color='primary'
                        type='submit'
                        @click='validateInitManagerBalance'
                    >ثبت
                    </v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-form>


</template>

<script>
import moment from "moment-jalaali";
import axios from "axios";
import {createSupportRequest} from "@/plugins/createSupportRequest";
import CustomCurrencyInput from '@/components/CustomCurrencyInput';
import {mapActions, mapState} from "vuex";

export default {
    name: "managerBalance",
    components: {
        CustomCurrencyInput
    },
    props: {
        apartment: Object,
        goToStep: Function,
        step: Number,
        supportRequest_id: String
    },
    model: {
        prop: 'apartment',
        event: 'updateApartment'
    },
    data() {
        return {
            managerBalance: null,
            disabled: false,
            loading: false,
            validInitManagerBalance: true,
            loadingSubmitInitManagerBalance: false,
            rules: {
                managerBalance: [
                    v => !v ? v < 0 ? 'مبلغ کمتر از ۰ قابل قبول نیست' : true : true
                ],
            },

            cashDesks: [],

            invoice: {
                hasInvoiceItems: false,
                type: '',
                category: '',
                title: '',
                amount: '',
                date: moment(new Date()).format('jYYYY/jMM/jDD'),
                description: '',
                invoiceItems: null,
                cashDesk: null,
                status: '',
                receiptPhoto: '',
                photos: [],
                senders: [],
                receivers: []
            },
        }
    },
    methods: {
        validateInitManagerBalance() {
            this.$refs['init-manager-balance-form'].validate();
            this.showNavigationBar();
        },

        async fetchApartmentCashDeskData() {
            await axios
                .get(`/api/apartments/${this.apartment._id}/cashDesks`)
                .then(res => {

                    this.apartment.cashDesks = res.data.apartment.cashDesks;
                    this.$emit('updateApartment', this.apartment);
                })
                .catch(error => {
                    console.error(error);
                });
        },

        async createInvoice(amount) {
            if (amount > 0) {
                this.loading = true;
                await this.fetchApartmentCashDeskData();
                console.log(typeof this.apartment.cashDesks[0]);
                if (typeof this.apartment.cashDesks[0] !== 'string' && this.apartment.cashDesks[0].invoices && this.apartment.cashDesks[0].invoices.length === 0) {
                    let data = {
                        invoiceFor: 'INVOICE',
                        amount: amount,
                        contact: {
                            onModel: 'User',
                            item: this.user._id
                        },
                        hasInvoiceItems: false,
                        invoiceItems: null,
                        type: 'INCOME',
                        category: 'OTHER',
                        title: 'موجودی اولیه',
                        pay_at: moment(new Date()).format('jYYYY/jMM/jDD'),
                        apartment_id: this.apartment._id,
                        cashDesk: this.cashDesks[0],
                        date: moment(this.invoice.date, 'jYYYY/jMM/jDD').format('YYYY/MM/DD'),
                        status: 'PAYED',
                        description: 'این مبلغ در هنگام ایجاد مجموعه توسط مدیر اظهار شده که به صورت موجودی اولیه نزد مدیر می‌باشد',
                        clientCallback: `/Invoices/?ref=apartment&ref_id=${this.apartment_id}`
                    };
                    await axios
                        .post(`/api/invoices`, data)
                        .then(async () => {
                            await createSupportRequest(this.supportRequest_id, {
                                text: 'ثبت موجودی اولیه صندوف'
                            });

                            this.loading = false;
                            this.$snackbar.showMessage({
                                content: 'موجودی اولیه صندوق مجموعه ثبت شد',
                                color: 'success',
                                timeout: 3000
                            });
                            this.showNavigationBar();

                            this.goToStep(this.step + 1);
                        })
                        .catch(err => {
                            console.error(err);
                            if (err.response) {
                                this.error = err.response;
                                this.errorDialog = true;
                            }
                            this.showNavigationBar();
                            this.loading = false;
                            console.log(err);
                        });
                } else {
                    this.loading = false;
                    this.$snackbar.showMessage({
                        content: 'موجودی اولیه صندوق مجموعه از قبل ثبت شده است برای ویرایش در لیست صورت حساب ,ایجاد صورت حساب جدید کنید',
                        color: 'warning',
                        timeout: 5000
                    });
                    this.goToStep(this.step + 1);
                    this.showNavigationBar();
                }
            } else {
                this.goToStep(this.step + 1);
            }

        },

        hideNavigationBar() {
            this.showNavigation(false);
        },
        showNavigationBar() {
            this.showNavigation(true);
        },
        ...mapActions([
            'setRole',
            'showNavigation',
            'showBreadCrumbs',
            'setBreadCrumbsTemp'
        ])
    },
    computed: {

        ...mapState(['user'])
    },
}
</script>

<style scoped>

</style>